const model = {
  requesting: false,
  locationSet: false,
  countryCode: null,
  latitude: null,
  longitude: null,
  region: null,
  city: null,
  district: null
}
export default model;
